// extracted by mini-css-extract-plugin
module.exports = {"buttons":"SharePanel-module--buttons--1KfKr","shareButton":"SharePanel-module--shareButton--2hgXN"};